import React from 'react';
import PropTypes from 'prop-types';

import { Criterium, CriteriumSocialSection } from '@hydra/common/criterium';

export const LinkedIn = ({ criterium }) => {
  const { data, url } = criterium;
  const {
    urls,
    name,
    confidence
  } = data;

  const content = (
    <CriteriumSocialSection
      isDetected
      network='LinkedIn'
      username={name}
      confidence={confidence}
      urls={urls}
      sections={[
        { name: 'linkedin_url', node: urls[0] },
        { name: 'linkedin_name', node: name }
      ]}
    />
  );

  return (
    <Criterium
      criterium={criterium}
      variables={{ domain: url }}
    >
      {content}
    </Criterium>
  );
};

LinkedIn.propTypes = {
  criterium: PropTypes.shape({
    data: PropTypes.shape({
      urls: PropTypes.arrayOf(PropTypes.string),
      name: PropTypes.string,
      confidence: PropTypes.number
    })
  })
};

export default React.memo(LinkedIn);
